import { useEffect } from 'react';
import useUmamiTracker from './useUmamiTracker';
import { MetricActions, MetricCategories } from './TrackEventParams';

export const ApplicationLoadedTracker = () => {
  const { trackEvent } = useUmamiTracker();

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      trackEvent({ category: MetricCategories.Application, action: MetricActions.Loaded });
    }, 1000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [trackEvent]);

  return null;
};
